import React from "react";
import ReactDOM from "react-dom";
import Cookies from "universal-cookie";
import { Provider } from "react-redux";
import App from "./App";
import lang from "./Lang.scss";
import CONFIG from "./config";
import "./fonts/Fonts.scss";
import "./index.scss";
import makeStore from "./store/Store";
import ConnectedIntlProvider from "./helper/ConnectedIntlProvider";

const store = makeStore(window.INITIAL_STATE);
const cookies = new Cookies("");

ReactDOM.render(
  <Provider store={store}>
    <ConnectedIntlProvider>
      <App store={store} />
    </ConnectedIntlProvider>
  </Provider>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept("./App", () => {
    const NextApp = require("./App").default;
    ReactDOM.render(
      <Provider store={store}>
        <ConnectedIntlProvider>
          <NextApp store={store} />
        </ConnectedIntlProvider>
      </Provider>,
      document.getElementById("root")
    );
  });
}

const COOKIE_DOMAIN =
  "." +
  window.location.hostname
    .split(".")
    .slice(-2)
    .join(".");

if (document && typeof document.URL !== "undefined") {
  const url = document.URL.replace(/^(?:\/\/|[^\/]+)*\//, "/");
  if (url === "/") {
    if (cookies.get("lang") && cookies.get("lang") === "ar") {
      window.location = "/ar-ae/";
    } else {
      window.location = "/en-ae/";
    }
  } else if (url === "/ar") {
    window.location = "/ar-ae/";
  } else if (url === "/ar/") {
    window.location = "/ar-ae/";
  } else if (url.indexOf("/en/") !== -1) {
    window.location = url.replace("/en/", "/en-ae/");
  } else if (url.indexOf("/ar/") !== -1) {
    window.location = url.replace("/ar/", "/ar-ae/");
  } else if (url.indexOf("/en") === -1 && url.indexOf("/ar") === -1) {
    window.location = `/en-ae${url}`;
  }
}

window.addEventListener("DOMContentLoaded", function() {
  document.getElementById("root").style.display = "none";
  const addStylesNode = document.getElementById("deferred-styles");
  const replacement = document.createElement("div");
  if (addStylesNode) {
    replacement.innerHTML = addStylesNode.textContent;
    document.body.appendChild(replacement);
    addStylesNode.parentElement.removeChild(addStylesNode);
    document.getElementById("mainCSS").addEventListener("load", function() {
      document.getElementById("root").style.visibility = "visible";
      document.getElementById("root").style.display = "block";
      const event = document.createEvent("HTMLEvents");
      event.initEvent("cssLoaded", true, true);
      window.dispatchEvent(event);
    });
  } else {
    document.getElementById("root").style.display = "block";
    const event = document.createEvent("HTMLEvents");
    event.initEvent("cssLoaded", true, true);
    window.dispatchEvent(event);
  }

  if (cookies.get("lang") === "ar") {
    document.getElementById("root").className = lang.ar_font;
  }
});



// WEBPACK FOOTER //
// ./src/index.js